import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

import { MasterPageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import { Confirmation } from '../components/modals/common';
import { HeaderMenu, DragAndDropWrapper } from '../components/ProgressBase';
import {
  HEADER_CONSTANTS_PROGRESS,
  TITLE_BROWSER_PROGRESS,
} from '../utilities/constants';
import dialogLoader from '../utilities/dialogLoader';
import { messageUtility } from '../utilities/messageUtility';
import { setMaxHeightTable } from '../utilities/constWijmo';
import SessionStorageService from '../services/utilities/SessionStorageService';
import ProgressService from '../services/Progress';
import IconProgress from '../images/icon-progress.svg';

export class ProgressChangeOrderOfWorkType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleDialogName: false,
      listMainWorkTypes: [],
      listSubWorkTypes: [],
      mainWorkId: null,
      dragSort: [],
      isShowPopupError: false,
      messageError: '',
    };

    this.fieldId = SessionStorageService.getFieldId();

    this.events = {
      dialog: {
        goBack: this.handleGoBackDialog,
      },
    };

    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          window.location.replace('/progress/0/0/0/ProgressSchedule:1/0:0');
        },
      },
    };
    this.isSubmitingFlag = false;
    this.isProgressFlg = parseInt(SessionStorageService.getUseProgressFlag());
  }

  componentDidMount() {
    if (!this.isProgressFlg) {
      return window.location.replace('/error-permission');
    }
    this.getFieldMainWorkTypes();
    const divFixed = document.querySelector('.fixed-scroller-header');
    if (divFixed) {
      const params = {
        heightOfTable: 'calc(100vh - 85px)',
        heightOfTableHaveNoti: 'calc(100vh - 125px)',
        heghtOfTableIpad: 'calc(100vh - 180px)',
        heightOfTableIpadHaveNoti: 'calc(100vh - 220px)',
      };
      setMaxHeightTable(divFixed, params);
    }
  }

  getFieldMainWorkTypes = async () => {
    const response = await ProgressService.getProgressFieldMainWorkTypes(
      this.fieldId,
      {
        include_sub_work_types_flag: 1,
        is_limit: 0,
      }
    );
    if (response.result) {
      const listMainWorkTypes = _.map(
        _.get(response, 'data.entities.field_main_work_types'),
        mainWork => {
          const { duplicate_name_flag, name, template } = mainWork;
          return !duplicate_name_flag
            ? mainWork
            : { ...mainWork, name: `${name} (${template.name})` };
        }
      );
      this.setState({
        listMainWorkTypes,
      });
    }
  };

  updateOrderFieldWorkTypes = async () => {
    const { listMainWorkTypes } = this.state;
    let field_main_work_types = [];
    field_main_work_types = _.map(listMainWorkTypes, mainWork => ({
      id: mainWork.id,
      field_sub_work_type_ids: _.map(
        mainWork.field_sub_work_types,
        subWork => subWork.id
      ),
    }));
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;

    const response = await ProgressService.updateProgressOrderFieldWorkTypes(
      this.fieldId,
      { field_main_work_types }
    );
    this.isSubmitingFlag = false;
    if (response.result) {
      return this.GoBack.callback.clear();
    }
    const message =
      _.get(response, 'data.message') || messageUtility.getMessage('E-000-001');
    this.setState({
      isShowPopupError: true,
      messageError: message,
    });
  };

  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  handleVisibleDialog = (name, visible) => {
    this.setState({
      [name]: visible,
    });
  };

  handleConfirmSubWorkList = mainWorkId => {
    const { listMainWorkTypes, listSubWorkTypes } = this.state;
    const newListMainWorkTypes = _.map(listMainWorkTypes, item => {
      return item.id !== mainWorkId
        ? item
        : { ...item, field_sub_work_types: listSubWorkTypes };
    });
    this.setState(
      {
        listMainWorkTypes: newListMainWorkTypes,
      },
      () => this.handleVisibleDialog('visibleDialogName', false)
    );
  };

  setMainWorkId = mainWorkId => {
    const mainWork = _.find(
      this.state.listMainWorkTypes,
      item => item.id === mainWorkId
    );
    this.setState(
      {
        mainWorkId,
        listSubWorkTypes: mainWork.field_sub_work_types,
      },
      () => {
        this.handleVisibleDialog('visibleDialogName', true);
      }
    );
  };

  setDefaultMainWork = () => {
    this.setState({
      listMainWorkTypes: _.sortBy(this.state.listMainWorkTypes, [
        'default_order_number',
      ]),
    });
  };

  setDefaultSubWork = () => {
    const { listMainWorkTypes, mainWorkId } = this.state;
    const listSubWorkTypes = _.find(
      listMainWorkTypes,
      item => item.id === mainWorkId
    );
    this.setState({
      listSubWorkTypes: _.sortBy(listSubWorkTypes.field_sub_work_types, [
        'default_order_number',
      ]),
    });
  };

  setListWorkTypes = (key, list) => {
    this.setState({ [key]: list });
  };

  sortList = (dragIndex, index, work) => {
    const checkType = work === 'main';
    const { listMainWorkTypes, listSubWorkTypes } = this.state;
    let list = _.cloneDeep(checkType ? listMainWorkTypes : listSubWorkTypes);
    const formItem = list[dragIndex];
    if (index < dragIndex) {
      list.splice(index, 0, formItem);
      list.splice(dragIndex + 1, 1);
    } else {
      list.splice(index + 1, 0, formItem);
      list.splice(dragIndex, 1);
    }
    this.setListWorkTypes(
      checkType ? 'listMainWorkTypes' : 'listSubWorkTypes',
      list
    );
  };

  dragOrDrop = (type, work) => {
    const checkType = type === 'drag';
    const index = checkType ? 0 : 1;
    return (dragProps, dropProps) => {
      this.setState(
        state => {
          state.dragSort[index] = checkType ? dragProps.index : dropProps.index;
          return state;
        },
        () => !checkType && this.sortList(...this.state.dragSort, work)
      );
    };
  };

  render() {
    const {
      listMainWorkTypes,
      listSubWorkTypes,
      mainWorkId,
      visibleDialogName,
      isShowPopupError,
      messageError,
    } = this.state;
    return (
      <div className='master-slide-view show ProgressChangeOrderOfWorkType'>
        <Helmet>
          <link rel='icon' href={IconProgress} />
          <title>{TITLE_BROWSER_PROGRESS.progressChangeOrder}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={HEADER_CONSTANTS_PROGRESS.progressChangeOrder}
            disableHelpMenu
          />
          <div className='master-slide-view__table fixed-scroller-header'>
            <div className='master-slide-view__table--menu'>
              <HeaderMenu
                confirmUpdate={this.updateOrderFieldWorkTypes}
                goBack={this.events.dialog.goBack}
                isDisabledUpdate={false}
              />
              <div className='ProgressChangeOrderOfWorkType--btn-reset'>
                <button
                  className='btn-text--sm'
                  onClick={this.setDefaultMainWork}
                >
                  デフォルトの並び順に戻す
                </button>
              </div>
            </div>
            <div className='master-slide-view__body'>
              <ListSortMainWork
                listMainWorkTypes={listMainWorkTypes}
                setMainWorkId={this.setMainWorkId}
                onBeginDrag={this.dragOrDrop('drag', 'main')}
                onDropped={this.dragOrDrop('drop', 'main')}
              />
              <Confirmation
                rootClassName='ProgressChangeOrderOfWorkTypeDialog'
                visible={visibleDialogName}
                message={
                  <ListSortSubWork
                    listMainWorkTypes={listMainWorkTypes}
                    mainWorkId={mainWorkId}
                    onBeginDrag={this.dragOrDrop('drag', 'sub')}
                    onDropped={this.dragOrDrop('drop', 'sub')}
                    resetListSortSubWork={this.setDefaultSubWork}
                    listSubWorkTypes={listSubWorkTypes}
                  />
                }
                title='小工種の並び順変更'
                multilineText={true}
                confirmButtonText='決定'
                cancelButtonText='キャンセル'
                buttonClassName='btn'
                effectiveButtonClassName='btn'
                onCancel={() =>
                  this.handleVisibleDialog('visibleDialogName', false)
                }
                onConfirm={() => this.handleConfirmSubWorkList(mainWorkId)}
              />
              <Confirmation
                rootClassName='ProgressErrorDialog'
                visible={isShowPopupError}
                message={messageError}
                title={messageUtility.getMessage('E-001-402')}
                multilineText={true}
                cancelButtonText={messageUtility.getMessage('I-000-017')}
                confirmButtonText={messageUtility.getMessage('I-000-180')}
                onCancel={() => {
                  this.handleVisibleDialog('isShowPopupError', false);
                }}
                onConfirm={() => {
                  this.handleVisibleDialog('isShowPopupError', false);
                  this.getFieldMainWorkTypes();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ListSortMainWork = ({
  listMainWorkTypes,
  onBeginDrag,
  onDropped,
  setMainWorkId,
}) => {
  const columnHeaders = ['', '大工種', ''];
  return (
    <DragAndDropWrapper
      columnHeaders={columnHeaders}
      listData={listMainWorkTypes}
      setMainWorkId={setMainWorkId}
      onBeginDrag={onBeginDrag}
      onDropped={onDropped}
      type='main'
    />
  );
};

const ListSortSubWork = ({
  listMainWorkTypes,
  resetListSortSubWork,
  onBeginDrag,
  onDropped,
  mainWorkId,
  listSubWorkTypes,
}) => {
  const columnHeaders = ['', '小工種'];

  return (
    <DragAndDropWrapper
      columnHeaders={columnHeaders}
      listMainWorkTypes={listMainWorkTypes}
      listData={listSubWorkTypes}
      mainWorkId={mainWorkId}
      resetListSortSubWork={resetListSortSubWork}
      onBeginDrag={onBeginDrag}
      onDropped={onDropped}
      type='sub'
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/ProgressChangeOrderOfWorkType.jsx